import Vue from 'vue';
import WalletBar from '../../parts/WalletBar.vue';
import Calculator from '../../parts/Calculator.vue';
import { getXemRate } from "../../../lib/exchangeUtils";
import { roundAt } from "../../../lib/numberUtils";
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
import { Decimal } from 'decimal.js';
export default Vue.extend({
    components: {
        Calculator,
        WalletBar
    },
    name: "QRGeneratorAmount",
    data() {
        return {
            rate: new Decimal(0),
            baseIsXem: true,
        };
    },
    methods: {
        getTargetPrice(basePrice) {
            if (this.rate === new Decimal(0)) {
                return new Decimal(0);
            }
            if (this.baseIsXem) {
                return new Decimal(basePrice).mul(this.rate);
            }
            else {
                return new Decimal(basePrice).div(this.rate);
            }
        },
        getXemAmount() {
            let xem = new Decimal(this.$store.state.calculatorValue);
            if (!this.baseIsXem) {
                xem = this.getTargetPrice(xem.toNumber());
            }
            return Math.round(xem.mul(Math.pow(10, 6)).toNumber());
        },
        onClickedBaseChange() {
            const targetValue = this.getTargetPrice(this.$store.state.calculatorValue);
            this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_FORMULA, targetValue.toString());
            this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_VALUE, targetValue);
            this.baseIsXem = !this.baseIsXem;
        }
    },
    mounted() {
        getXemRate().then((rate) => {
            this.rate = roundAt(rate, 5);
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/qrlab/QRGeneratorAmount.vue
// module id = 646
// module chunks = 1